import { OnExchangeEnrollPersonI } from './on-exchange-enroll.person.interface';

export interface ProductInfo {
  ratingEntity: any;
  productCode: string;
  region: string;
  merchantId: string;
  groupNumber: string;
  lob: string;
  planArea: string;
  planId: string;
}
export interface CoverageInfo {
  effectiveDateValue: string;
  premiumAmount: string;
  coverageCategoryCode: string;
  applicationReceiptDate: string;
}
export interface OtherHealthInfo {
  medicareQuestionInd: string;
  privateOrGovernmentInd: unknown;
  privateOrGovernment: {
    fullyConsumedBenefitsInd: string;
    insuranceCarrier: string;
    groupNumber: string;
    policyHolder: string;
    effectiveDate: string;
    policyNumber: string;
    relationshipToApplicant: string;
    relationshipToApplicantCode: string;
    policyHolderBirthDate: string;
    policyHolderEmploymentStatus: string;
    policyHolderEmploymentStatusCode: string;
  };
  replaceAnyOtherCoverageInd: string;
  replaceAnyOtherCoverage: {
    insuranceCarrier: string;
    groupNumber: string;
    policyHolder: string;
    effectiveDate: string;
    policyNumber: string;
    relationshipToApplicant: string;
    relationshipToApplicantCode: string;
    policyHolderBirthDate: string;
    policyHolderEmploymentStatus: string;
    policyHolderEmploymentStatusCode: string;
  };
  pcp: {
    name: string;
    number: string;
    pcpInd: boolean | string;
  };
}
export interface ProducerInfo {
  agencyNumber: string;
  agencyName: string;
  producerNumber: string;
  producerName: string;
  businessPhoneNumber: string;
  relevantMarketingMaterialsInd: boolean | string;
  productFeaturesAdviceInd: boolean | string;
  currentCustomerInd: boolean | string;
  signedCopyInd: boolean | string;
  producerAwareness: string;
  eSignature: boolean;
  npn: string;
}
export interface ProducerCollaborationInfo {
  producerNumber: string;
  agencyNumber: string;
  npn: string;
}

export interface OnExchangeEnrollDataTemplate {
  transactionId: any;
  submissionDate: any;
  FFMPolicyNumber: any;
  status: unknown;
  poBoxedApplication: any;
  hasResidency: boolean;
  thirdPartyPayer: any;
  thirdPartyPayerType: any;
  thirdPartyPayerName: any;
  communicationPreferenceIndicator: any;
  ichra: boolean;
  qsehra: boolean;
  enrollmentChannel: string;
  planNotice: any;
  wellnessNotice: any;
  coachNotice: any;
  memberNotice: any;
  appSubmitTimestamp?: unknown;
  prospectId?: string; // Added in enroll-manager.service
  applicationId?: string; // Added in enroll-manager.service

  product: ProductInfo;
  coverage: CoverageInfo;
  persons: OnExchangeEnrollPersonI[];
  otherHealthInsuranceInformation: OtherHealthInfo;
  childOnlyApplication: unknown;
  producerInd: unknown;
  producer: ProducerInfo;
  producerCollaborationInd: unknown;
  producerCollaboration: ProducerCollaborationInfo;
}

export const RAW_OnExchangeEnrollDataTemplate: OnExchangeEnrollDataTemplate = {

  /** From Response */
  transactionId: null,
  submissionDate: null,
  FFMPolicyNumber: null,
  status: null,
  poBoxedApplication: null,
  hasResidency: null,
  thirdPartyPayer: null,
  thirdPartyPayerType: null,
  thirdPartyPayerName: null,
  communicationPreferenceIndicator: null,
  ichra: null,
  qsehra: null,
  enrollmentChannel: null,
  planNotice: null,
  wellnessNotice: null,
  coachNotice: null,
  memberNotice: null,

  /** From Selected Plan */
  product: {
    productCode: null,
    region: null,
    merchantId: null,
    groupNumber: null,
    lob: null,
    planArea: null,
    planId: null,
    ratingEntity: null
  },

  /** From Meta Info */
  coverage: {
    effectiveDateValue: null,
    premiumAmount: null,
    coverageCategoryCode: null,
    applicationReceiptDate: null
  },
  childOnlyApplication: null,
  persons: [],
  otherHealthInsuranceInformation: {
    medicareQuestionInd: null,
    privateOrGovernmentInd: null,
    privateOrGovernment: {
      fullyConsumedBenefitsInd: null,
      insuranceCarrier: null,
      groupNumber: null,
      policyHolder: null,
      effectiveDate: null,
      policyNumber: null,
      relationshipToApplicant: null,
      relationshipToApplicantCode: null,
      policyHolderBirthDate: null,
      policyHolderEmploymentStatus: null,
      policyHolderEmploymentStatusCode: null
    },
    replaceAnyOtherCoverageInd: null,
    replaceAnyOtherCoverage: {
      insuranceCarrier: null,
      groupNumber: null,
      policyHolder: null,
      effectiveDate: null,
      policyNumber: null,
      relationshipToApplicant: null,
      relationshipToApplicantCode: null,
      policyHolderBirthDate: null,
      policyHolderEmploymentStatus: null,
      policyHolderEmploymentStatusCode: null
    },
    pcp: {
      name: null,
      number: null,
      pcpInd: null
    }
  },
  producerInd: null,
  producer: {
    agencyNumber: null,
    agencyName: null,
    producerNumber: null,
    producerName: null,
    businessPhoneNumber: null,
    relevantMarketingMaterialsInd: null,
    productFeaturesAdviceInd: null,
    currentCustomerInd: null,
    signedCopyInd: null,
    producerAwareness: null,
    eSignature: null,
    npn: null
  },
  producerCollaborationInd: null,
  producerCollaboration: {
    producerNumber: null,
    agencyNumber: null,
    npn: null
  }
};
